<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/admon')" style="cursor: pointer">Administración</li>
        <li class="breadcrumb-item active" aria-current="page">Reembolsar</li>
      </ol>
    </nav>

    <section class="move-charges container-fluid">
      <vx-card title="Reembolsar">
        <div class="search-input">

          <div class="row flex">
            <vs-input
              label-placeholder="Buscar"
              v-model="id_project"
              @keyup.native.enter="getProject"
              @blur="getProject"
              :disabled="loading">
              <template #icon>
                <em class="fa fa-search"></em>
              </template>
            </vs-input>

            <template v-if="project_data !== ''">
              <vs-button
                class="small mt-5 ml-4"
                :disabled="project_data.refunded"
                color="success"
                @click="showDialogTotal = true">
                Reembolsar todo el proyecto
              </vs-button>
              <vs-button class="small flex-2 mt-5 ml-4" primary v-if="false" @click="showDialogPartial = true">Reembolso
                parcial
              </vs-button>
              <vs-button class="small flex-2 mt-5 ml-4" primary v-if="false" @click="showDialogMove = true">Mover fondos
                a
                otro proyecto
              </vs-button>
              <vs-button class="small flex-2 mt-5 ml-4" primary @click="refundSingle()">Reembolsar a
                {{ refundPartialConfig.length }} inversionistas
              </vs-button>
            </template>
          </div>

          <vs-alert color="warning mt-3" v-if="project_data.refunded">Reembolsado</vs-alert>
        </div>

        <div class="results container" v-if="project_data !== ''">
          <div class="row flex">
            <card-result
              class="flex-1 m-5"
              icon="DollarSignIcon"
              icon-right
              statistic="Inversiones"
              color="warning"
              :text="project_data.total.toString()"
              :hide-chart="true"/>

            <card-result
              class="flex-1 m-5"
              icon="DollarSignIcon"
              icon-right
              statistic="Total invertido"
              color="warning"
              :text="project_data.total_amount"
              :hide-chart="true"/>

            <card-result
              class="flex-1 m-5"
              icon="DollarSignIcon"
              icon-right
              statistic="Reembolsado"
              color="warning"
              :text="project_data.total_refund"
              :hide-chart="true"/>

            <card-result
              v-if="refundPartialConfig.length > 0"
              class="flex-1 m-5"
              icon="DollarSignIcon"
              icon-right
              statistic="A Reembolsar"
              color="success"
              :text="sum_pending_for_refund"
              :hide-chart="true"/>
          </div>
        </div>

        <div class="row flex">
          <vs-table class="flex-1" :data="project_data.investors" stripe>
            <template slot="thead">
              <vs-th>IID</vs-th>
              <vs-th>IUD</vs-th>
              <vs-th>Inversionista</vs-th>
              <vs-th>Invertido</vs-th>
              <vs-th>Reembolsar</vs-th>
              <vs-th>Reembolsado</vs-th>
              <vs-th></vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="investor in data" :key="investor.id">
                <vs-td class="text-left">{{ investor.id }}</vs-td>
                <vs-td class="text-left">{{ investor.user_id }}</vs-td>
                <vs-td class="text-left">{{ investor.email }}</vs-td>
                <vs-td class="text-right table-number">{{ investor.now_invested }}</vs-td>
                <vs-td>
                  <vs-input v-if="isSelected(investor.id)" v-model="findItem(investor.id).amount" placeholder="Monto a reembolsar"></vs-input>
                </vs-td>
                <vs-td class="text-right table-number">{{ investor.now_refund }}</vs-td>
                <vs-td class="text-center">
                  <input type="checkbox" :value="investor.id" @change="addInvestor(investor)" :disabled="loading">
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>


      <!--Menú reembolso total-->
      <vs-popup :active.sync="showDialogTotal" title="Reembolso Total">
        <label>Reembolso total del proyecto {{ project_data.project_id }}.</label><br>
        <label><strong>Monto a reembolsar:</strong> ${{ project_data.total_amount }}</label><br>
        <label><input type="checkbox" v-model="pen"> Dispersar comisión de preoriginación</label>
        <template v-if="pen">
          <vs-select
              class="w-full mt-6"
              label="¿A quién quieres reembolsar la comisión de preoriginación?"
              v-model="refund_opening_commission_actor">
            <vs-select-item value="applicant" text="Solicitante"></vs-select-item>
            <vs-select-item value="investor" text="Inversionistas"></vs-select-item>
          </vs-select>
        </template>
        <div class="row p-5">
          <vs-button class="small mr-2" @click="showDialogTotal = false">Cancelar</vs-button>
          <vs-button class="small" @click="refundAll()">Reembolsar</vs-button>
        </div>
      </vs-popup>


      <!--Menú reembolso parcial-->
      <vs-popup :active.sync="showDialogPartial" title="Reembolso Parcial">
        <vs-input
            label="Monto a reembolsar"
            v-model="partial_amount"
            v-money="money"></vs-input>

        <div class="mt-6">
          <vs-button @click="showDialogPartial = false;  partial_amount = 0;">Cancelar</vs-button>
          <vs-button @click="refundPartial()">Reembolsar</vs-button>
        </div>
      </vs-popup>
      <!--Menú mover fondos-->
      <vs-popup title="Mover fondos" :active.sync="showDialogMove" style="width:30%">
        <vs-input label="Mover fondos a otro proyecto" type="number" v-model="target_project"></vs-input>

        <div class="mt-6">
          <vs-button @click="showDialogPartial = false;  target_project = '';">Cancelar</vs-button>
          <vs-button @click="moveFunds()">Mover</vs-button>
        </div>
      </vs-popup>
    </section>
  </div>

</template>

<script lang="js">
import DispersionTotalCard from "@/views/admin/treasury/dispersions/components/dispersion-total-card";
import CardResult from "@/views/admin/admon/Refund/CardResult";
import _ from "lodash";

export default {
  name: 'move-charges',
  components: {CardResult, DispersionTotalCard},
  props: [],
  data() {
    return {
      refund: [],
      refundPartialConfig: [],
      id_project: '',
      project_data: '',
      amount: 0,
      total: 0,
      loading: false,
      moved: false,
      form: true,
      pen: false,
      com_amount: 0,
      refund_investors: [],
      showDialogTotal: false,
      showDialogPartial: false,
      showDialogMove: false,
      partial_amount: 0,
      refund_opening_commission_actor: null,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        suffix: '',
        precision: 2,
        masked: false
      },
      target_project: '',
    }
  },
  computed: {
    sum_pending_for_refund() {
      return _.sumBy(this.refundPartialConfig, (item) => parseFloat(item.amount)).toString()
    },
  },
  methods: {
    addInvestor(investor) {
      if(!this.isSelected(investor.id)) {
        this.refundPartialConfig.push({
          investor_id: investor.id,
          amount: parseFloat(investor.invested.replace(",", ""))
        })
      } else {
        this.unselectItem(investor.id);
      }
    },
    unselectItem(investor_id) {
      this.refundPartialConfig = this.refundPartialConfig.filter((item) => item.investor_id !== investor_id);
    },
    filterByInvestorId(investor_id) {
      return this.refundPartialConfig.filter((item) => item.investor_id === investor_id);
    },
    findItem(investor_id) {
      return this.filterByInvestorId(investor_id)[0] || {};
    },
    isSelected(investor_id) {
      return this.filterByInvestorId(investor_id).length > 0
    },
    getProject() {
      if (this.id_project !== '') {
        this.refund_investors = [];
        axios.get('/api/refund-project/' + this.id_project)
          .then(response => {
            this.project_data = response.data
          })
      } else {
        this.errorNotif("Aviso", 'Ingresa el ID del proyecto al que se le asignarán los fondos', 4000);
      }
    },
    refundAll() {
      var message = 'Confirmar reembolso total del proyecto ' + this.project_data.project_id + '\nMonto total a reembolsar: $' + this.project_data.total_amount;
      if (this.pen) {
        message = message + '\nComisión por apertura incluida'
      }
      var confirm = window.confirm(message);
      if (!confirm) {
        return 0;
      }
      this.showDialogTotal = false
      var data = {
        project: this.project_data.project_id,
        pen: this.pen,
        type: 'project',
        refund_opening_commission_actor: this.refund_opening_commission_actor
      }
      this.disperse(data);
    },
    async refundPartial() {
      var message = 'Confirmar reembolso total del proyecto ' + this.project_data.project_id + '\nMonto total a reembolsar: $' + this.project_data.total_amount;
      var confirm = window.confirm(message);
      if (!confirm) {
        return 0;
      }
      var s = this.partial_amount.replace('$', '')
      s = s.replace(',', '')
      s = s.replace(',', '')
      s = s.replace(',', '')
      var amount = parseFloat(s)
      if (amount <= 0) {
        return 0;
      }

      try {
        this.showDialogPartial = false
        this.loading = true
        var response = await axios.post('/api/refund-project/parcial', {
          project: this.project_data.project_id,
          amount: amount
        });
        this.successNotif("Aviso", "Reembolsado", 4000);
        this.partial_amount = 0;
        this.getProject();
      } catch (e) {
        Vue.toasted.clear()
        if (e.response != undefined && e.response.data != undefined && e.response.data.message != undefined) {
          this.errorNotif("Aviso", e.response.data.message, 4000);
        } else {
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      }
      this.loading = false
    },
    async moveFunds() {
      var message = 'Confirmar mover fondos del proyecto ' + this.project_data.project_id + ' al proyecto ' + this.target_project;
      var confirm = window.confirm(message);
      if (!confirm) {
        return 0;
      }

      if (this.target_project == '') {
        return 0;
      }

      try {
        this.showDialogMove = false
        this.loading = true
        var response = await axios.post('/api/refund-project/reinvertir', {
          current_project: this.project_data.project_id,
          target_project: this.target_project
        });
        this.successNotif("Aviso", "Fondos colocados", 4000);
        this.target_project = '';
        this.getProject();

      } catch (e) {
        Vue.toasted.clear()
        if (e.response != undefined && e.response.data != undefined && e.response.data.message != undefined) {
          this.errorNotif("Aviso", e.response.data.message, 4000);
        } else {
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      }
      this.loading = false
    },
    async refundSingle() {
      if (confirm('Reembolsar inversión a ' + this.refundPartialConfig.length + ' inversionistas')) {
        try {
          this.loading = true
          await axios.post(`/api/project/refund/partial`, {
            refund: this.refundPartialConfig,
            project_id: this.project_data.project_id,
          })
          this.successNotif("Aviso", "Reembolsado", 4000);
          this.loading = false
          this.getProject();
        } catch (e) {
          this.loading = false
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      }
    },
    disperse(data) {
      if (this.id_project != '' && this.project_data) {
        this.loading = true
        axios.post('/api/refund-project', data)
          .then(response => {
            this.successNotif("Aviso", "Reembolsado", 4000);
            this.loading = false
            this.getProject();
          }).catch(error => {
          this.loading = false
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        })
      } else {
        this.errorNotif("Aviso", 'Ingresa el ID del proyecto al que se le asignarán los fondos', 4000);
      }
    },
    apertura() {
      if (this.id_project != '' && this.project_data) {
        Vue.toasted.clear()
        Vue.toasted.show('Dispersando...', {position: 'bottom-center', closeOnSwipe: false});
        var data = {
          project: this.id_project,
          amount: this.com_amount
        }
        axios.post('/api/refund-project/apertura', data)
          .then(response => {
            Vue.toasted.clear()
            this.successNotif("Aviso", "Dispersado", 4000);
          }).catch(error => {
          Vue.toasted.clear()
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        })
      } else {
        Vue.toasted.clear()
        this.errorNotif("Aviso", 'Ingresa el ID del proyecto al que se le asignarán los fondos', 4000);
      }
    }
  },
}
</script>

<style scoped lang="scss">
.move-charges {

}

td {
  width: 25%;
}

th {
  text-align: center;
}

div {
  font-size: 15px;
}
.md-option {
  z-index: 1000;
}

.bar {
  width: 100%;
  height: 20px;
  border: 1px solid #212529;
  border-radius: 3px;
  background-image: repeating-linear-gradient(
      -45deg,
      #212529,
      #212529 11px,
      #fff 10px,
      #fff 20px /* determines size */
  );
  background-size: 28px 28px;
  animation: move .5s linear infinite;
}
.md-menu-content.md-select-menu {
  z-index: 1000;
}
@keyframes move {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 28px 0;
  }
}

</style>
